import * as React from "react";
import { scroller } from "react-scroll";
import ItemPicker from "../../../../ui-library/item-picker/item-picker";
import { EventCategory } from "../../../../../utils/analytics";
import Actionable from "../../../../ui-library/actionable/actionable";
import HeightTransition from "../../../../ui-library/height-transition/height-transition";
import { ACTIONS_TO_WIN } from "./actions-to-win";
import ActionCard from "./action-card";
import styles from "./actions-card-group.styles";

interface ActionItemProps {
  order: number;
  title: string;
  description: string;
  why: string[];
  how: string[];
}

const tabs = ["Why", "How"];

const ActionItem: React.FC<ActionItemProps> = (action) => {
  const [isOpen, setOpen] = React.useState<boolean>(false);
  const [activeTab, setActiveTab] = React.useState<string>(tabs[0]);

  const id = `howToWin_${action.order}`;
  const ctaText = isOpen ? "Close why and how" : "See why and how";

  return (
    <ActionCard key={action.title} id={id} css={styles.card}>
      <h3 css={styles.heading}>
        <span css={styles.order}>{action.order}</span>
        {action.title}
      </h3>
      <div css={styles.content}>{action.description}</div>
      <HeightTransition
        isClosed={!isOpen}
        transitionTime={0.2}
        transitionMargin={100}
      >
        <div css={styles.detailContainer}>
          <ItemPicker
            itemPickerName="winningActionWhyAndHow"
            isUniWidth={true}
            items={tabs.map((t) => ({
              label: t,
              value: t,
            }))}
            activeItemValue={activeTab}
            onItemClick={setActiveTab}
            eventCategory={EventCategory.CovidHowToWin}
          />

          {activeTab === tabs[0] &&
            action.why.map((item) => (
              <div key={item} css={styles.listItem}>
                {item}
              </div>
            ))}
          {activeTab === tabs[1] &&
            action.how.map((item) => (
              <div key={item} css={styles.listItem}>
                {item}
              </div>
            ))}
        </div>
      </HeightTransition>
      <Actionable
        role="button"
        ariaLabel={ctaText}
        onClick={() => {
          setOpen(!isOpen);
          if (!isOpen) {
            scroller.scrollTo(id, { smooth: true, offset: -30 });
          }
        }}
        css={styles.cta}
        analytics={{
          category: EventCategory.CovidHowToWin,
          action: `Click - ${ctaText}`,
          label: ctaText,
        }}
      >
        {ctaText}
      </Actionable>
    </ActionCard>
  );
};

const ActionsCardGroup: React.FC = () => {
  return (
    <>
      {ACTIONS_TO_WIN.map((action) => (
        <ActionItem key={action.title} {...action} />
      ))}
    </>
  );
};

export default ActionsCardGroup;
